import type {PropsWithChildren, ReactNode} from "react";

export function RegistryShell({title, description, tools, state, children}: PropsWithChildren<{
  title: string;
  description: string;
  tools?: ReactNode;
  state?: ReactNode;
}>) {
  return <section className="registry-shell" aria-labelledby="registry-title">
    <header className="registry-heading">
      <div><p className="eyebrow">Registry</p><h1 id="registry-title">{title}</h1><p>{description}</p></div>
      {tools && <div className="registry-tools">{tools}</div>}
    </header>
    {state ?? children}
  </section>;
}
